<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<h1 class="chapter"><span class="big">MOVIE<br/>for<br/>DOGS</span></h1>
<h1 class="chapter"><span class="small1">BY</span> L<span class="small1">OIS</span> D<span class="small1">UNCAN</span></h1>
<p class="center"><img alt="" src="OEBPS/images/logo.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780545388856_epub_tp_r1.vue?d6df8d54